import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/image_google_appstore.png")